import { Flex, Image, Text, Box } from '@chakra-ui/core'
import React from 'react'
import { Maybe, TaskDefinitionEntity } from '../../../../generated/graphql'
import { Card } from '../../../../components'
import { images } from '../../../../theme'
import { CardProps } from '../../../../components/Card'

type ListItemProps = {
  task: Maybe<TaskDefinitionEntity>
} & CardProps
const ListItem: React.FC<ListItemProps> = ({ task, ...rest }) => {
  return (
    <Card rounded="lg" p={4} mb={3} mr={2} cursor={'pointer'} minW={48} {...rest}>
      <Flex>
        <Image
          src={
            task?.attributes?.category?.data?.attributes?.featureImage?.data?.attributes?.formats
              ?.thumbnail?.url || images.baotreeLogo
          }
          alt={task?.attributes?.project?.data?.attributes?.name || 'Project Image'}
          objectFit="cover"
          rounded="lg"
          w={38}
          h={38}
          mr={3}
          bg="gray.100"
          p={1}
        />
        <Box>
          <Text fontSize="sm" fontWeight="500" color="gray.700">
            {task?.attributes?.task_type?.data?.attributes?.title || 'Unknown Task'}
          </Text>
          <Text fontSize="xs" color="gray.500">
            {task?.attributes?.project?.data?.attributes?.name || 'Unknown Project'}
          </Text>
        </Box>
      </Flex>
    </Card>
  )
}

export default ListItem
